import { UserRole } from '../interfaces/user-role';
import { isManagementRole, isRepresentativeRole } from './user-roles';

export function canManageCustomerDrafts(
  role: UserRole | null | undefined,
): boolean {
  return isRepresentativeRole(role);
}

export function canAcceptCustomerDrafts(
  role: UserRole | null | undefined,
): boolean {
  return isManagementRole(role);
}
